import React from "react";
import { Card, CardContent } from "./ui/card";
import {
  DollarSign,
  Download,
  ChevronRight,
  ExternalLink,
  Wallet,
} from "lucide-react";

const RewardsAlreadyGivenScreen = ({
  buyerData,
  onViewWallet,
  onDownloadApp,
}) => {
  // Extract rewards from buyerData
  const rewards = buyerData.allRewards || [buyerData];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center space-y-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <DollarSign className="w-8 h-8 text-green-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">
          You've Been Rewarded!
        </h1>
        <p className="text-gray-600">
          Your insurance profile has already earned you a reward.
        </p>
      </div>

      {/* Rewards Card */}
      <Card className="border-green-100 bg-green-50">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center gap-4">
            <div className="flex items-center gap-2">
              <Wallet className="w-5 h-5 text-green-600" />
              <h3 className="font-medium">Your Reward</h3>
            </div>

            <div className="w-full space-y-3">
              {rewards.map((reward, index) => {
                // Get buyer info, handling potential missing properties
                const buyer = reward.buyer || {};
                const amount = reward.amount || reward.offer?.amount || 0;
                const shopUrl = buyer.shopNowLink || buyer.websiteLink;

                return (
                  <div
                    key={index}
                    className="flex flex-col p-4 bg-white rounded-lg border border-green-100"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        {buyer.logo && (
                          <img
                            src={buyer.logo}
                            alt={buyer.name || "Partner"}
                            className="h-10 w-auto object-contain"
                          />
                        )}
                        <div>
                          <p className="font-medium text-gray-900">
                            {buyer.name || "Insurance Partner"}
                          </p>
                          <p className="text-sm text-gray-600">
                            ${parseFloat(amount).toFixed(2)} added to your
                            wallet
                          </p>
                        </div>
                      </div>

                      <div className="flex items-center">
                        <p className="text-sm font-medium text-green-600">
                          Received
                        </p>
                      </div>
                    </div>

                    {/* Shop Now button - prominently displayed */}
                    {buyer.shopNowLink && (
                      <a
                        href={buyer.shopNowLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-3 flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors w-full"
                      >
                        Shop Now with {buyer.name || "Partner"}
                        <ExternalLink className="w-4 h-4" />
                      </a>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Next Steps */}
      <Card>
        <CardContent className="pt-6">
          <h3 className="font-medium text-gray-900 mb-4">What's Next?</h3>

          <div className="grid grid-cols-1 gap-3">
            {/* Wallet Option */}
            <button
              onClick={onViewWallet}
              className="flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Wallet className="w-5 h-5 text-blue-500" />
                <div className="text-left">
                  <p className="font-medium text-gray-900">View Your Wallet</p>
                  <p className="text-sm text-gray-600">
                    Access your rewards and track earnings
                  </p>
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </button>

            {/* Download App Option */}
            <button
              onClick={onDownloadApp}
              className="flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Download className="w-5 h-5 text-blue-500" />
                <div className="text-left">
                  <p className="font-medium text-gray-900">
                    Download Ownli App
                  </p>
                  <p className="text-sm text-gray-600">
                    Earn more rewards on the go
                  </p>
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </button>
          </div>
        </CardContent>
      </Card>

      {/* Data Value Explainer */}
      {/* <Card className="bg-blue-50 border-blue-100">
        <CardContent className="pt-6">
          <div className="text-center">
            <p className="text-sm text-blue-700">
              Your data has value! Insurance companies are willing to pay for access to quality profiles like yours.
            </p>
          </div>
        </CardContent>
      </Card> */}

      {/* Footer */}
      <p className="text-xs text-center text-gray-500">
        Thank you for using Ownli. You can access your rewards anytime through
        the Ownli app or website.
      </p>
    </div>
  );
};

export default RewardsAlreadyGivenScreen;
